export default __webpack_public_path__ + "static/media/meal-snack-icon.9e0ef07c.svg";